import React from 'react';

import AdminReferralConversationPage from './AdminReferralConversationPage';

const AdminReferralConversationAsOffererPage: React.FC = () => (
  <AdminReferralConversationPage viewAsRole="offerer" />
);

export default AdminReferralConversationAsOffererPage;
